import { AspectRatio, Box, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

const Foundation = () => {
  return (
    <VStack mt={8} w="100%">
      <Text
        textTransform="uppercase"
        textStyle="docMainTitle"
        textAlign="center"
      >
        USE IT WITH FOUNDATION
      </Text>
      <VStack mt={6} w="100%">
        <AspectRatio
          mt={5}
          w={{
            base: '90%',
            sm: '540px',
            md: '700'
          }}
          ratio={700 / 149}
          position="relative"
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/mix-1711001501809.png"
            alt="mix"
            fill
          />
        </AspectRatio>
      </VStack>
    </VStack>
  )
}
export default Foundation
